/**
 * Shared react-query keys used across admin modules.
 * Keep floorplan invalidation in one place so workspace / assignment
 * mutations and the map stay in sync.
 */
export const FLOORPLAN_QUERY_KEY = ["admin", "floorplan"] as const;
